module.exports = {
          srcSet: __webpack_public_path__ + "fb5f6afa7ef5bc928d93b2a4fb2563e6-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "fb5f6afa7ef5bc928d93b2a4fb2563e6-180.png",width: 180,height: 6}],
          src: __webpack_public_path__ + "fb5f6afa7ef5bc928d93b2a4fb2563e6-180.png",
          toString:function(){return __webpack_public_path__ + "fb5f6afa7ef5bc928d93b2a4fb2563e6-180.png"},
          
          width: 180,
          height: 6
        }